import "core-js/stable"
import "regenerator-runtime/runtime"
import "../style.scss"
import Automount from "utils/automount-next"

// Import jQuery and Bootstrap for tooltips
import $ from 'jquery'
import 'bootstrap'
window.$ = $
window.jQuery = $

import "@hotwired/turbo-rails"
import "~/controllers"

import '../registration/floating_labels.scss'

import { Formulus } from "../registration/formulus"
Formulus.initialize({ autoAttach: true })
